module.exports = __webpack_public_path__ + "img/base.30eab460.png";